import React, { createContext, useState, useRef, useContext } from 'react';
import classnames from 'classnames';
import { faBars } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var SortableListBoxContext = /*#__PURE__*/createContext(null);

var SortableListBox = function SortableListBox(_ref) {
  var ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    className = _ref.className,
    _onDrop = _ref.onDrop;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    ariaLiveText = _useState2[0],
    setAriaLiveText = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedItemIndex = _useState4[0],
    setSelectedItemIndex = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    inAccessibleMoveMode = _useState6[0],
    setInAccessibleMoveMode = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDraggingItem = _useState8[0],
    setIsDraggingItem = _useState8[1];
  var listBoxRef = useRef(null);
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    draggingOptionHeight = _useState10[0],
    setDraggingOptionHeight = _useState10[1];
  var calculateTargetIndex = function calculateTargetIndex(option, moveNext) {
    var newOption = option;
    if (option < children.length - 1 && moveNext) {
      newOption += 1;
    } else if (option === children.length - 1 && moveNext) {
      newOption = 0;
    } else if (option > 0 && !moveNext) {
      newOption -= 1;
    } else if (option === 0 && !moveNext) {
      newOption = children.length - 1;
    }
    return newOption;
  };
  var getOptionIndexFromElement = function getOptionIndexFromElement(element) {
    while (!element.hasAttribute('data-listbox-index')) {
      if (element.parentElement === listBoxRef.current || element.parentElement === null) {
        throw new Error('Unable to find parent element with "data-listbox-index" set for element clicked inside SortableListBox');
      }
      element = element.parentElement;
    }
    return parseInt(element.getAttribute('data-listbox-index'));
  };
  var handleMoveSelectedKeyDown = function handleMoveSelectedKeyDown(event, idx) {
    var newOption = idx;
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      newOption = calculateTargetIndex(idx, true);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      newOption = calculateTargetIndex(idx, false);
    }
    setSelectedItemIndex(newOption);
    setAriaLiveText('');
  };
  var handleDragDropKeyDown = function handleDragDropKeyDown(event) {
    var target = event.target;
    if (target.tagName !== 'LI' && target.tagName !== 'UL' && !target.hasAttribute('data-listbox-index')) return;
    var idx = getOptionIndexFromElement(target);
    var ariaLiveText = '';
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      if (inAccessibleMoveMode) {
        event.preventDefault();
        var moveNext = event.key === 'ArrowDown';
        var startIndex = selectedItemIndex !== null && selectedItemIndex !== void 0 ? selectedItemIndex : 0;
        var newIndex = calculateTargetIndex(idx, moveNext);
        handleReorder(startIndex, newIndex);
        var grabbedOptionName = target.getAttribute('data-name');
        ariaLiveText = updateAssistiveText(grabbedOptionName, newIndex, false, true);
        setAriaLiveText(ariaLiveText);
      } else {
        handleMoveSelectedKeyDown(event, idx);
      }
    } else if (event.key === 'Enter') {
      event.preventDefault();
      setSelectedItemIndex(idx);
      var _grabbedOptionName = target.getAttribute('data-name');
      ariaLiveText = updateAssistiveText(_grabbedOptionName, selectedItemIndex !== null && selectedItemIndex !== void 0 ? selectedItemIndex : 0, inAccessibleMoveMode, false);
      setAriaLiveText(ariaLiveText);
      setInAccessibleMoveMode(!inAccessibleMoveMode);
    }
  };
  var handleReorder = function handleReorder(startIndex, endIndex) {
    _onDrop(startIndex, endIndex);
    setSelectedItemIndex(endIndex);
    setIsDraggingItem(false);
  };
  var updateAssistiveText = function updateAssistiveText(element, index, drop, move) {
    var updatedString = element;
    if (!drop && !move) {
      updatedString += ' grabbed, current ';
    }
    if (!drop && move) {
      updatedString += ' moved, new ';
    }
    if (drop) {
      updatedString += ' dropped, final ';
    }
    updatedString += "position ".concat(index + 1, " of ").concat(children.length);
    return updatedString;
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SortableListBoxContext.Provider, {
    value: {
      isDragging: isDraggingItem,
      setIsDragging: setIsDraggingItem,
      inAccessibleMoveMode: inAccessibleMoveMode,
      selectedOptionIndex: selectedItemIndex,
      setSelectedOptionIndex: setSelectedItemIndex,
      onDrop: function onDrop(e) {
        if (!isDraggingItem) return;
        var targetIdx = getOptionIndexFromElement(e.currentTarget);
        setIsDraggingItem(false);
        _onDrop(selectedItemIndex !== null && selectedItemIndex !== void 0 ? selectedItemIndex : 0, targetIdx);
      },
      draggingOptionHeight: draggingOptionHeight,
      setDraggingOptionHeight: setDraggingOptionHeight
    }
  }, /*#__PURE__*/React.createElement(AssistiveText, {
    ariaLiveText: ariaLiveText
  }), /*#__PURE__*/React.createElement("ul", {
    "aria-label": ariaLabel,
    "aria-describedby": "instructions",
    className: className,
    // @ts-expect-error typing
    onKeyDown: handleDragDropKeyDown,
    onBlur: function onBlur() {
      setInAccessibleMoveMode(false);
    },
    role: "listbox",
    ref: listBoxRef
  }, children)));
};
var AssistiveText = function AssistiveText(_ref2) {
  var ariaLiveText = _ref2.ariaLiveText;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    id: "instructions",
    "aria-label": "Press enter to toggle drag drop mode, use arrow keys to move selected elements."
  }), /*#__PURE__*/React.createElement("div", {
    "aria-live": "assertive",
    "aria-label": ariaLiveText
  }));
};

var useStyles = makeStyles(function (theme) {
  return {
    listItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      cursor: 'grab',
      padding: '14px 0',
      '&:focus, &:hover': {
        background: '#f3f2f2'
      },
      '&:focus': {
        outline: "1px solid ".concat(theme.palette.divider)
      }
    },
    selected: {
      fontStyle: 'italic'
    },
    dragBackground: {
      '& .optionContainer': {
        opacity: 0.6
      }
    }
  };
});
var SortableListBoxOption = function SortableListBoxOption(_ref) {
  var name = _ref.name,
    index = _ref.index,
    children = _ref.children,
    className = _ref.className,
    optionContainerClassName = _ref.optionContainerClassName,
    dragIconContainerClassName = _ref.dragIconContainerClassName;
  var context = useContext(SortableListBoxContext);
  if (!context) {
    throw new Error('SortableListBoxOption must be used within a SortableListBoxContext');
  }
  var isDragging = context.isDragging,
    setIsDragging = context.setIsDragging,
    inAccessibleMoveMode = context.inAccessibleMoveMode,
    _onDrop = context.onDrop,
    selectedOptionIndex = context.selectedOptionIndex,
    setSelectedOptionIndex = context.setSelectedOptionIndex,
    draggingOptionHeight = context.draggingOptionHeight,
    setDraggingOptionHeight = context.setDraggingOptionHeight;
  var isSelected = selectedOptionIndex === index;
  var listItemRef = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    dragCounter = _useState2[0],
    setDragCounter = _useState2[1];
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Box, null, dragCounter > 0 && selectedOptionIndex !== undefined && index < selectedOptionIndex && ( /*#__PURE__*/React.createElement(Box, {
    style: {
      height: draggingOptionHeight
    },
    onDragEnter: function onDragEnter() {
      return setDragCounter(function (prev) {
        return prev + 1;
      });
    },
    onDragLeave: function onDragLeave() {
      return setDragCounter(0);
    },
    onDragOver: function onDragOver(e) {
      e.preventDefault();
    },
    onDrop: function onDrop(e) {
      _onDrop(e);
      setDragCounter(0);
    },
    "data-listbox-index": index,
    "data-name": name
  })), /*#__PURE__*/React.createElement("li", {
    "aria-selected": isSelected ? true : undefined,
    className: classnames(_defineProperty(_defineProperty({}, classes.selected, isSelected && inAccessibleMoveMode), classes.dragBackground, !isSelected && isDragging), classes.listItem, className),
    draggable: true,
    "data-listbox-index": index,
    "data-name": name,
    onClick: function onClick(e) {
      e.preventDefault();
      setSelectedOptionIndex(index);
    },
    onDragStart: function onDragStart(e) {
      var _a;
      if (e.dataTransfer) {
        e.dataTransfer.dropEffect = 'copy';
        setIsDragging(true);
        setSelectedOptionIndex(index);
        setDraggingOptionHeight(((_a = listItemRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0);
      }
    },
    onDragEnter: function onDragEnter(e) {
      e.preventDefault();
      if (selectedOptionIndex === index) return;
      setDragCounter(function (prev) {
        return prev + 1;
      });
    },
    onDragLeave: function onDragLeave(e) {
      e.preventDefault();
      setDragCounter(function (prev) {
        return prev > 0 ? prev - 1 : prev;
      });
    },
    onDragEnd: function onDragEnd(e) {
      e.preventDefault();
      setIsDragging(false);
      setSelectedOptionIndex(index);
    },
    ref: listItemRef,
    role: "option",
    tabIndex: isSelected || selectedOptionIndex === undefined && index === 0 ? 0 : -1,
    "aria-label": name
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    width: "100%",
    padding: "0 12px",
    className: classnames('optionContainer', optionContainerClassName)
  }, /*#__PURE__*/React.createElement(Box, {
    mr: "8px",
    pr: "8px",
    className: dragIconContainerClassName
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    "aria-hidden": true,
    icon: faBars
  })), children)), dragCounter > 0 && selectedOptionIndex !== undefined && index > selectedOptionIndex && ( /*#__PURE__*/React.createElement(Box, {
    style: {
      height: draggingOptionHeight
    },
    onDragEnter: function onDragEnter() {
      return setDragCounter(function (prev) {
        return prev + 1;
      });
    },
    onDragLeave: function onDragLeave() {
      return setDragCounter(function (prev) {
        return prev > 0 ? prev - 1 : prev;
      });
    },
    onDragOver: function onDragOver(e) {
      e.preventDefault();
    },
    onDrop: function onDrop(e) {
      _onDrop(e);
      setDragCounter(0);
    },
    "data-listbox-index": index,
    "data-name": name
  })));
};

export { SortableListBox, SortableListBoxOption };
//# sourceMappingURL=index.module.js.map
